<template lang="pug">
component(
  :is="component"
  v-bind="{ ...$props, ...$attrs }"
  @refresh="$emit('refresh')"
  @perform="opts => $emit('perform', opts)"
)
  //- v-on="$listeners"
  //- To pass on all events:
  //-   in vue-2 use: v-on="$listeners"
  //-   in vue-3 use: v-bind="$attrs"
</template>

<script>
import pagelets from '@/components/pagelets'

export default {
  inheritAttrs: false,

  components: {
    ...pagelets
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,   // @type {Keep.Paper.Design.Entity}
    pagelet: Object,  // @type {Keep.Paper.Design.Entity}

    busy: Boolean,
  },

  computed: {
    component() {
      const name = `Pagelet${this.pagelet?.type}`
      return pagelets[name] || 'PageletUnknown'
    },
  },

  methods: {
  },
}
</script>